import { VisibilityOutlined } from "@mui/icons-material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import PersonIcon from "@mui/icons-material/Person";
import { Tooltip } from "@mui/material";
import {
    BriefcaseBusiness,
    GraduationCap,
    IndianRupee,
    LaptopMinimal,
    MonitorPlay
} from "lucide-react";

import { useEffect, useState } from "react";
import { IoMan } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import CCService from "../../../../services/httpServiceWithoutSuperAdmin";

const CandidateCard = ({ candidate, job_id, onBookmarkChange }) => {
    const service = new CCService();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(null);
    const [isBookmarked, setIsBookmarked] = useState(false);
    useEffect(() => {
        const savedCandidates = JSON.parse(
            localStorage.getItem(`saved_candidates_${job_id}`) || "[]"
        );
        setIsBookmarked(savedCandidates.includes(candidate.user_id));
    }, [candidate.user_id, job_id]);

    const handleBookmarkToggle = (candidateId) => {
        try {
            const storageKey = `saved_candidates_${job_id}`;
            const savedCandidates = JSON.parse(
                localStorage.getItem(storageKey) || "[]"
            );

            let updatedCandidates;
            if (isBookmarked) {
                updatedCandidates = savedCandidates.filter((id) => id !== candidateId);
            } else {
                updatedCandidates = [...savedCandidates, candidateId];
            }

            localStorage.setItem(storageKey, JSON.stringify(updatedCandidates));

            setIsBookmarked(!isBookmarked);

            if (onBookmarkChange) {
                onBookmarkChange(candidateId, !isBookmarked);
            }
        } catch (error) {
            console.error("Error toggling bookmark:", error);
        }
    };

    const handleClick = async (event, userId) => {
        console.log("click called");
        event.preventDefault();
        try {
            setLoading(userId);
            const res = await service.get(
                `/user/userDetailByUserId?user_id=${userId}`
            );
            handleNavigation(res.userDetail.username);
        } catch (error) {
            console.log(error);
        }
    };
    const handleNavigation = (username) => {
        const url = `${process.env.REACT_APP_FRONTEND_URL}/candidates/${username}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="candidate-card !relative !overflow-hidden !py-4 !w-full !h-full !flex !flex-col !bg-white !rounded-lg !shadow-md !p-3 !justify-between">
            <div className="!flex !items-center !gap-1 !absolute !top-2 !right-2">
                <VisibilityOutlined
                    sx={{
                        color: "#1c8ea8",
                        fontSize: "14px",
                        opacity: parseInt(candidate.recruiter_views) === 0 ? 0 : 1,
                    }}
                />
                <p
                    className={`text-sm !p-0 !text-primary ${parseInt(candidate.recruiter_views) === 0 ? "opacity-0" : ""
                        }`}
                >
                    {parseInt(candidate.recruiter_views) || 0}
                </p>
                <span
                    className={`!text-primary !text-center !text-[14px] !font-inter ${parseInt(candidate.recruiter_views) === 0 ? "opacity-0" : ""
                        }`}
                >
                    Profile views
                </span>
            </div>
            <div className="!flex !items-start !justify-between !gap-4 !mb-1 !mt-4">
                <div className="!flex !items-start !gap-2">
                    <div className="!relative !w-12 !sm:w-14 !md:w-16 !lg:w-20 !aspect-square !min-w-[56px] !rounded-full !overflow-hidden !bg-gray-100 !flex !items-center !justify-center !text-[24px] !font-semibold !text-gray-600">
                        {candidate.profile_pic ? (
                            <img
                                src={candidate.profile_pic}
                                alt={candidate.full_name}
                                className="object-cover"
                            />
                        ) : (
                            candidate.full_name?.charAt(0)?.toUpperCase()
                        )}
                    </div>

                    <div>
                        <h2 className="!text-xl !lg:text-[22px] !mb-1 !font-medium !font-manrope !w-[90%] !overflow-hidden !text-ellipsis !whitespace-nowrap">
                            {candidate.full_name}
                        </h2>
                        <div className="!flex !items-center !gap-2">
                            {candidate.full_time ||
                                candidate.internship ||
                                candidate.project ? (
                                <h3 className="!text-sm !text-grey-700 !font-inter !ml-1">
                                    Open to:
                                </h3>
                            ) : null}
                            <div className="!flex !items-center !gap-2">
                                {candidate.project && (
                                    <Tooltip arrow title="Gig/Remote Internship">
                                        <div className="bg-backgroundColor rounded-full p-2">
                                            <LaptopMinimal
                                                size={16}
                                                strokeWidth={1.5}
                                                absoluteStrokeWidth
                                                className="text-white"
                                            />
                                        </div>
                                    </Tooltip>
                                )}
                                {candidate.internship && (
                                    <Tooltip arrow title="Full-time Internship">
                                        <div className="bg-[#167387] rounded-full p-2">
                                            <BriefcaseBusiness
                                                size={16}
                                                strokeWidth={1.5}
                                                absoluteStrokeWidth
                                                className="text-white"
                                            />
                                        </div>
                                    </Tooltip>
                                )}
                                {candidate.full_time && (
                                    <Tooltip arrow title="Permanent Employment">
                                        <div className="bg-[#16AA6B] rounded-full p-2">
                                            <MonitorPlay
                                                size={16}
                                                strokeWidth={1.5}
                                                absoluteStrokeWidth
                                                className="text-white"
                                            />
                                        </div>
                                    </Tooltip>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="!flex !items-center !gap-3 !text-primary1 !my-2 !min-w-0">
                <div className="!flex !items-center !gap-1 !min-w-0">
                    <IoMan size={20} color="#2ABBDB" />
                    <p className="!truncate !text-sm !md:text-md !lg:text-md !mb-2 !text-grey-700 !mt-2 !p-0">
                        {parseInt(String(candidate.age)) > 0
                            ? `${parseInt(String(candidate.age))} Yrs`
                            : "0 Yrs"}
                    </p>
                </div>

                <div className="w-[1.5px] h-4 bg-[#EDEDED] hidden md:block" />

                <div className="!flex !items-center !gap-1 !min-w-0">
                    <BriefcaseBusiness
                        size={20}
                        strokeWidth={1.5}
                        absoluteStrokeWidth
                        className="text-grey-700"
                    />
                    <p className="!truncate !text-sm !md:text-md !lg:text-md !font-medium !text-grey-700 !p-0">
                        {parseInt(candidate.total_work_ex_in_months) > 0
                            ? `${candidate.total_work_ex_in_months} Months`
                            : "Fresher"}
                    </p>
                </div>

                <div className="w-[1.5px] h-4 bg-[#EDEDED] hidden md:block" />

                <div className="!flex !items-center !gap-1 !min-w-0">
                    <GraduationCap
                        size={20}
                        strokeWidth={1.5}
                        absoluteStrokeWidth
                        className="text-grey-700"
                    />
                    <p className="!truncate !max-w-[80px] !text-sm !md:text-md !lg:text-md !font-medium !text-grey-700 !p-0">
                        {candidate.degree}
                    </p>
                </div>
            </div>

            <div className="!flex !items-center">
                <IndianRupee
                    size={18}
                    strokeWidth={1.5}
                    absoluteStrokeWidth
                    className="text-grey-700"
                />
                <AutoAwesomeIcon sx={{ color: "#F6AE2D", fontSize: "14px" }} />
                <p className="!text-sm !md:text-md !lg:text-md !font-medium !text-grey-700 !ml-2 !p-0">
                    Salary Intelligence: Not Available
                </p>
            </div>

            <div className="w-full h-0.5 bg-[#EDEDED] mt-6" />

            <span
                className="font-inter text-sm text-[#a8a8a8] mt-4 font-light"
                style={{ letterSpacing: "2px" }}
            >
                ROLE PREFERENCES
            </span>

            <div className="!flex !gap-2 !flex-wrap !mt-4">
                <div className="bg-[#F2F7F9] rounded-md px-2 py-1">
                    <span className="!text-sm !md:text-md !lg:text-md !font-medium !text-grey-700 !whitespace-nowrap">
                        {candidate.preferred_role_1}
                    </span>
                </div>
                <div className="bg-[#F2F7F9] rounded-md px-2 py-1">
                    <span className="!text-sm !md:text-md !lg:text-md !font-medium !text-grey-700 !whitespace-nowrap">
                        {candidate.preferred_role_2}
                    </span>
                </div>
                <div className="bg-[#F2F7F9] rounded-md px-2 py-1">
                    <span className="!text-sm !md:text-md !lg:text-md !font-medium !text-grey-700 !whitespace-nowrap">
                        {candidate.preferred_role_3}
                    </span>
                </div>
            </div>

            <div className="hover-overlay !absolute !inset-0 !p-4 !flex !flex-col !items-center !justify-center !opacity-0 !group-hover:opacity-100 !pointer-events-none !group-hover:pointer-events-auto !transition-all !duration-300 !rounded-lg">
                <span
                    className="font-inter text-sm text-grey-700 font-normal"
                    style={{ letterSpacing: 4 }}
                >
                    QUICK ACTIONS
                </span>
                <div className="w-full h-px bg-gray-400 my-3" />

                <div className="flex items-center gap-3 mt-4">
                    <a
                        href={candidate.page_link}
                        target="_blank"
                        onClick={(event) => handleClick(event, candidate.user_id)}
                    >
                        <button className="font-inter flex items-center justify-center gap-2 !bg-primary/1 !w-40 !text-primary !border-2 !border-primary !rounded-md !px-3.5 !py-0.5 !font-semibold !hover:bg-white !hover:border-white !transition-colors">
                            <PersonIcon /> View Profile
                        </button>
                    </a>

                    {isBookmarked ? (
                        <button
                            onClick={() => handleBookmarkToggle(candidate.user_id)}
                            className="font-inter flex items-center gap-2 !bg-primary/1 !text-primary !border-2 !border-primary !rounded-md !px-3.5 !py-0.5 !font-semibold !hover:bg-white !hover:border-white !transition-colors"
                        >
                            <BookmarkIcon
                                sx={{ color: "#1C8EA8", fontSize: 23, cursor: "pointer" }}
                            />
                            Save
                        </button>
                    ) : (
                        <button
                            onClick={() => handleBookmarkToggle(candidate.user_id)}
                            className="font-inter flex items-center gap-2 !bg-primary/1 !text-primary !border-2 !border-primary !rounded-md !px-3.5 !py-0.5 !font-semibold !hover:bg-white !hover:border-white !transition-colors"
                        >
                            <BookmarkBorderOutlinedIcon
                                sx={{ color: "#1C8EA8", fontSize: 23, cursor: "pointer" }}
                            />
                            Save
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CandidateCard;
